import { isEmpty } from 'lodash';

export const getValueOrDefaultIfEmpty = (value: any, defaultValue: string = '-') => {
  return !isEmpty(value) ? value : defaultValue;
};
